<template>
  <div class="popSearch">
    <!-- input框 -->
    <div class="parent">
      <div type="text"
           class="ginput"
           @click="openPop">
        <template v-if="disValue">{{disValue}}</template>
        <span v-else
              class="ph">{{placeholder}}</span>
      </div>
      <i class="iconfont icon-xia"
         @click="openPop"></i>
    </div>
    <!-- pop弹出层 -->
    <mt-popup v-model="popupVisible"
              position="right">
      <!-- 黑色头部插件 -->
      <div class="topsHeader">
        <mt-header :title="title"
                   fixed
                   :style="{backgroundColor:bgcolor}">
          <i class="mintui mintui-back"
             @click="leftBack()"
             slot="left"></i>
        </mt-header>
      </div>
      <!-- 弹出层内容（搜索和列表） -->
      <div class="autoSearch">
        <div class="autoSearchTop">
          <div class="searchBox">
            <mt-search v-model="value"
                       :placeholder="searchPlaceholder"
                       @input="input()"
                       :cancel-text="$t('cancel')"></mt-search>

            <div class="autocomplete transition"
                 v-show="showList">
              <ul>
                <li v-for="(data,index) in json"
                    transition="showAll"
                    class="listBox"
                    :key="index">
                  <a href="#"
                     @click.prevent="selectCompany(data)">
                    <div class="detail">
                      <div class="ct clearfix">
                        <div style="overflow:hidden">
                          <div style='overflow:hidden'>
                            <div class="info">
                              <!--公司-->
                              {{$t('incomeAccount_msg_ar_select_company')}}：{{data.name}}
                            </div>
                            <div class="info">
                              {{$t('incomeAccount_msg_ar_select_amount')}}：￥{{data.money}}
                            </div>
                          </div>

                          <div style='overflow:hidden'>
                            <div class="info">
                              {{$t('incomeAccount_msg_ar_arno')}}：{{data.arno}}
                            </div>

                            <div class="info">
                              {{$t('incomeAccount_msg_ar_coding')}}：{{data.coding}}
                            </div>
                          </div>

                          <div style='overflow:hidden'>
                            <div class="info"
                                 style='width: 25%'>
                              {{$t('status')}}：<span class='black-round'>{{data.sta}}</span>
                            </div>

                            <div class="info"
                                 style='width: 75%'>
                              {{$t('incomeAccount_msg_ar_avaliable_date')}}：{{data.arr | fDate}}
                              {{$t('incomeAccount_msg_ar_avaliable_date_center')}} {{data.dep | fDate}}
                            </div>
                          </div>
                          <div class="info"
                               style='width: 100%;'>
                            {{$t('remark')}}：{{data.remark}}{{data.remark}}
                          </div>

                          <i class="iconfont icon-you"
                             style="top:1rem"></i>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
                <nothing :condition="json == null ||json.length == 0"
                         :dis="json==null?$t('pop_search_searchTile'):$t('nothing')"></nothing>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </mt-popup>


    <mt-popup v-model="showPop"
              class='selectShift select-wrap-araccount'
              popup-transition="popup-fade">
      <h2>{{$t('incomeAccount_msg_ar_account')}}</h2>
      <div class='select-list-wrap'>
        <mt-radio
          v-model="arAccountId"
          :options="arAccountList">
        </mt-radio>
      </div>
      <div class="btn">
        <div class="unSure"
             @click="cancelSelectAccount">{{$t('cancel')}}
        </div>
        <div class="sure"
             @click="save">{{$t('determine')}}
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
  import {
    Popup
  } from "mint-ui";
  import moment from 'moment'
  import nothing from "../../../common/nothing";

  export default {
    data() {
      return {
        popupVisible: false,
        disValue: "",
        value: "", // 默认 ‘中’
        showList: true,
        isGroup: false,
        json: null,
        debounceTask: 500,
        placeholder: '',
        searchPlaceholder: '',
        title: '',

        arCompanyId: '', // 选中的公司 id
        arCompanyName: '',
        arAccountId: '', // 选中的账户 id
        arAccountName: '', // 选中的账户 name

        showPop: false,
        arAccountList: [], // ar账公司的人的列表
      };
    },
    props: {
      name: String,
      //JSON数据取值的Key
      anchor: {
        required: true
      },
      type: String,
      //这是黑色头部的prop
      back: {
        default: true
      },

      searchNow: {
        default: true
      },
      bgcolor: {
        default: "#393C41"
      }
    },
    mounted() {
      this.placeholder = this.$t('incomeAccount_msg_ar_select_company')
      // this.placeholder = '公司'
      this.title = this.placeholder;
    },
    methods: {
      //打开popup弹框
      openPop() {
        this.popupVisible = !this.popupVisible;
        this.resetValue()
        if (this.searchNow) {
          if (!this.json) {
            this.getData();
          }
        }
      },

      resetValue() {
        this.arCompanyId = '' // 选中的公司 id
        this.arCompanyName = ''
        this.arAccountId = '' // 选中的账户 id
        this.arAccountName = '' // 选中的账户 name
        this.disValue = ''

        this.$emit("onSelect", {
          arCompanyId: '',
          arAccountId: ''
        });
      },

      cancelSelectAccount() {
        this.showPop = false
        this.arCompanyId = '' // 选中的公司 id
        this.arCompanyName = ''
        this.arAccountId = '' // 选中的账户 id
        this.arAccountName = '' // 选中的账户 name
        this.disValue = ''
      },
      //选中列表中的哪一项
      selectCompany(data) {
        if (data.sta != 'I') {
          this.msg2(this.$t('incomeAccount_msg_ar_no_status'))
        } else if (new Date(data.dep) < new Date()) {
          this.msg2(this.$t('incomeAccount_msg_ar_no_date'))
        } else {
          this.arCompanyId = data.id
          this.arCompanyName = data.name
          this.disValue = data[this.anchor];
          this.getArPayGroupAccountList(data)
        }
      },

      save() {
        if (this.getArAccountName()) {
          this.disValue = this.arCompanyName + ' - ' + this.getArAccountName()
        } else {
          this.disValue = this.arCompanyName
        }
        this.popupVisible = false;
        this.showPop = false
        this.$emit("onSelect", {
          arCompanyId: this.arCompanyId + '',
          arAccountId: this.arAccountId + ''
        });
      },

      getArAccountName() {
        let str = ''
        if (this.arAccountList && this.arAccountList.length > 0) {
          this.arAccountList.map((item, index) => {
            if (item.id == this.arAccountId) {
              str = item.name
            }
          })
        }
        return str
      },

      setInValue(v) {
        this.disValue = v;
        this.value = v;
      },

      searchData() {
        this.getData(this.value);
      },

      /*协议公司/旅行社/中介searchText*/
      async getData(value) {
        await this.$http
          .post("/mobilepmsapi/accounting/arPayGroupSelect", {
            con: value,
          })
          .then(res => {
            if (res.data.result == 0) {
              let retVal = res.data.retVal || {}
              this.json = retVal.arGroup || [];
            }
          });
      },

      getArPayGroupAccountList(data) {
        const self = this
        this.$http
          .post("/mobilepmsapi/accounting/arPayGroupAccountSelect", {
            id: data.id,
          })
          .then(res => {
            if (res.data.result == 0) {
              let retVal = res.data.retVal || {}
              let arr = retVal.arAccount || [];
              self.arAccountList = []
              arr.map((item, index) => {
                // 为了使用 mint ui的 radio，格式改一下
                item.label = item.id + ' - ' + item.name
                item.value = item.id + '' || ''
                self.arAccountList.push(item)
              })
              if (self.arAccountList && self.arAccountList.length > 0) {
                this.showPop = true
              } else {
                this.save()
              }
            }
          });
      },

      clearData() {
        this.value = "";
        this.disValue = "";
        this.json = null;
      },
      input() {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.json = null;
        this.debounceTask = setTimeout(() => {
          this.searchData();
        }, 1000);

      },
      //下面都是黑色头部事件
      leftBack() {
        this.popupVisible = false;
      },
      gohome() {
        this.$router.push("/");
      },
      refresh() {
        location.reload();
      }
    },
    watch: {},
    created() {
    },
    components: {
      Popup,
      nothing,
    },
    filters: {
      fDate(value) {
        return moment(value).format("YYYY-MM-DD");
      }
    }
  };
</script>

<style lang="less">
  .popSearch {
    float: right;

    .select-wrap-araccount {
      width: 80%;
      position: fixed;
      margin: 0 auto;
      background-color: #fff;
      border-radius: 10px;
      overflow: hidden;

      .select-list-wrap {
        min-height: 320px;
        max-height: 380px;
        overflow-y: scroll;
      }

      .mint-radiolist-title {
        display: none;
      }

      .mint-radiolist-label {
        width: auto !important;
      }


      h2 {
        font-size: 18px;
        color: #666666;
        text-align: center;
        font-style: normal;
        padding: 15px 0;
      }

      .mint-cell-title {
        width: 80px;
      }

      .btn {
        height: 55px;
        border-top: 1px solid #bdbdbd;
        text-align: center;
        font-size: 16px;
        width: 100%;

        .unSure {
          border-right: 1px solid #bdbdbd;
          width: 50%;
          box-sizing: border-box;
          float: left;
          line-height: 55px;
        }

        .sure {
          width: 50%;
          box-sizing: border-box;
          float: left;
          line-height: 55px;
          color: #5190c3;
        }

        .unSure,
        .sure {
          &:active {
            background: #eaeaea;
          }
        }
      }
    }

    .parent {
      position: relative;
      margin: 0 0.13333333rem;
      padding: 0 0.13333333rem;
      float: right;
      width: 6.76666667rem !important;
      box-sizing: border-box;
      height: 0.88rem;
      background: #fff;
      border: 1px solid #e8e8e8;

      .iconfont {
        position: absolute;
        right: 0.26666667rem;
        top: 0px;
      }
    }

    .mint-popup-right {
      width: 100%;
      height: 100%;

      .topsHeader {
        z-index: 2000;
        position: fixed;
        height: 1.04rem;

        .mint-header {
          color: #fff;
          font-size: 16px;
          top: -1px;
          z-index: 100;
          padding: 0;

          .mint-header-button {
            padding: 0 0.2rem;

            .mintui-back {
              font-size: 0.7rem;
              line-height: 0.853333rem;
            }

            .mint-button {
              .mint-button-icon {
                float: right;
              }
            }
          }
        }
      }

      .autoSearch {
        position: fixed;
        top: 1.04rem;
        left: 0;
        z-index: 1000;
        width: 100%;
        background: #fff;
        height: 100%;

        .mint-searchbar {
          background: none;
          border-radius: 5px;
        }

        .mint-searchbar-inner {
          background: #efefef;
          border-radius: 1rem;
        }

        .mint-searchbar-core {
          text-indent: 0.3rem;
          background: #efefef;
          border: none !important;
        }

        .mintui-search {
          font-size: 0.5rem;
          margin-left: 0.2rem;
        }

        .mint-searchbar-cancel {
          color: #000;
        }

        .mint-cell-wrapper {
          font-size: 0.35rem;
          border-bottom: 1px solid #ccc;
          width: 90%;
          margin: 0 auto;
        }

        .mint-search-list {
          top: 8px;
          // .mint-search-list-warp {
          //   border-top: 5px solid #efefef;
          // }
        }

        .autoSearchTop {
          background-color: #fff;
          height: 1.666667rem;
        }

        .mint-search-list-warp .mint-cell:nth-of-type(1) .mint-cell-wrapper {
          background-image: none;
        }
      }
    }

    .autocomplete {
      position: fixed;
      top: 2.3rem;
      width: 100%;
      height: ~"calc(100% - 4rem)";
      overflow: hidden;
      padding-bottom: 2rem;

      ul {
        margin: 0 4px;
        height: 100%;
        overflow-y: scroll;

        .listBox {
          padding-top: 5px;
          border-bottom: 2px solid #e8e8e8;
        }

        li {
          a {
            .detail {
              width: 100%;
              line-height: 14px;
              font-size: 12px;
              background-color: #fff;
              border-bottom: none;

              .top {
                padding: 6px 8px;
                color: #000;
                border-bottom: 1px dashed #ddd;

                .left {
                  float: left;
                }

                .right {
                  float: right;

                  span {
                    color: #d0011b;
                  }
                }
              }

              .ct {
                overflow: hidden;

                .info {
                  color: #333;
                  float: left;
                  box-sizing: border-box;
                  height: auto;
                  line-height: 14px;
                  font-size: 12px;
                  overflow: hidden;
                  margin: 0.1rem 0;
                  word-wrap: break-word;
                }

                .info {
                  width: 50%;
                }

                .info:nth-of-type(1n) {
                  padding-right: 5px;
                  box-sizing: border-box;
                }

                .black-round {
                  display: inline-block;
                  background: #333;
                  color: #fff;
                  width: 14px;
                  height: 14px;
                  border-radius: 14px;
                  text-align: center;
                  line-height: 14px;
                  font-size: 12px;
                }

                .iconfont {
                  position: absolute;
                  right: -1px;
                  font-size: 0.34rem;
                  top: 0;
                  color: #9b9b9b;
                }
              }
            }
          }
        }
      }
    }

    .transition,
    .autocomplete,
    .showAll-transition,
    .autocomplete ul,
    .autocomplete ul li a {
      transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
    }

    .autocomplete ul li a {
      text-decoration: none;
      display: block;
      color: #000;
      padding: 5px;
    }

    .autocomplete ul li a b {
      font-weight: normal;
    }

    .autocomplete ul li {
      width: 100%;
      background: #fff;
      position: relative;
      z-index: 1;
      height: auto;
      line-height: 21px;
      font-size: 12px;
    }

    .showAll-transition {
      opacity: 1;
      height: 50px;
      overflow: hidden;
    }

    .showAll-enter {
      opacity: 0.3;
      height: 0;
    }

    .showAll-leave {
      display: none;
    }

    .ph {
      color: #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// popSearchArPayGroup.vue?efceacd6